import { API_URL } from "../config/connect";

/**
 * Toggles auto-renewal for a promotion
 * @param {number} promotionId - The ID of the promotion
 * @param {boolean} autoRenewal - Enable (true) or disable (false) auto-renewal
 * @returns {Promise<Object>} Response object with updated auto-renewal status
 */
export async function toggleAutoRenewal(promotionId, autoRenewal) {
    try {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        const endpoint = `${API_URL}/api/v1/promotion/${promotionId}/auto-renewal`;

        const response = await fetch(endpoint, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                auto_renewal: autoRenewal
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: response.statusText }));
            throw new Error(errorData.detail || `Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to toggle auto-renewal:', error);
        throw error;
    }
}


